import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Flex } from 'foundations-components/components/Flex';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { GUIDANCE_MODAL_WIDTH } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Empty State Guidance Modal
 *
 * When more than two choices are possible for Users (self service, taking a tour and Generative AI for example),
 * it is recommended to use this modal instead of adding more than two CTAs directly in EmptyState.
 *
 * @param title Title of the modal, should communicate the tool's goal
 * @param description Supporting content, should briefly explain how the onboarding can assist the User
 * @param onClose Will close the modal, usually provided by `OpenModalButton` {@link https://git.hubteam.com/HubSpot/growth-onboarding-empty-states/blob/master/growth-onboarding-empty-states/static-1.5838/js/components/OpenModalButton.tsx}
 * @param children Add the modal CTA here from the list in `growth-onboarding-empty-states/static-1.5838/js/GuidanceModal/buttons`
 */
const GuidanceModal = ({
  title,
  description,
  onClose,
  children
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: GUIDANCE_MODAL_WIDTH,
    "data-test-id": "empty-state-guidance-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      use: "toolbar",
      paddingInlineEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        paddingBlockStart: "900",
        children: title
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose,
        "data-test-id": "empty-state-guidance-modal-close-button"
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "600",
        children: description
      }), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        alignItems: "stretch",
        gap: "400",
        children: children
      })]
    })]
  });
};
export default GuidanceModal;